import PianoOpzioniCard
    from "../../../../contratto-digitale/digital-contract-details/tabs/offerte/offerte-cards/piano-opzioni-card/PianoOpzioniCard";
import Typography from "@material-ui/core/Typography";
import {useSelector} from "react-redux";

const OfferteConsip = () => {
    const offerteTables = useSelector(state => state.ordiniConsipReducer.ordiniConsipDetailsOfferta.data);
    const loading = useSelector(state => state.ordiniConsipReducer.ordiniConsipDetailsOfferta.loading);

    return (
        <>
            <Typography variant="h6" className={"mt-12 mb-24"}>
                Offerte incluse nel contratto
            </Typography>
            <PianoOpzioniCard
                comesFromConsip
                cardTitle={"Piani commerciali sottoscritti"}
                tableOneDescription={"Voce e Dati"}
                tableOneData={offerteTables.pianiVoceDatiList}
                loading={loading}
                tableTwoDescription={"Dati"}
                tableTwoData={offerteTables.pianiDataList}
            />
            <PianoOpzioniCard
                comesFromConsip
                isPachetti
                cardTitle={"Pachetti aggiuntivi"}
                tableOneDescription={"Pacchetti aggiuntivi Voce / SMS / MMS"}
                tableOneData={offerteTables.pachettiVoceSmsMms}
                loading={loading}
                tableTwoDescription={"Pacchetti aggiuntivi Dati"}
                tableTwoData={offerteTables.pachettiDati}
                tableThreeDescription={"Pacchetti giornalieri in roaming non regolamentato"}
                tableThreeData={offerteTables.pachettiRoamingNonRegolamentato}
            />
        </>
    )
}

export default OfferteConsip;